import React from "react";
import styled from "styled-components";
import { Product } from "../../api/productService";

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 0.7rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(233, 125, 125, 0.04);
`;
const Th = styled.th`
  background: #faf9f9;
  color: #e97d7d;
  font-weight: 700;
  padding: 1rem;
  border-bottom: 1.5px solid #f0eaea;
`;
const Td = styled.td`
  padding: 1rem;
  border-bottom: 1px solid #f0eaea;
`;
const Tr = styled.tr<{ odd?: boolean }>`
  background: ${(p) => (p.odd ? "#fff2f2" : "#fff")};
`;
const ActionBtn = styled.button`
  background: #e97d7d;
  color: #fff;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 1.2rem;
  margin-right: 0.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #d96a6a;
  }
`;

const ProductsTable: React.FC<{
  products: Product[];
  onEdit: (product: Product) => void;
  onDelete: (id: string) => void;
}> = ({ products, onEdit, onDelete }) => {
  return (
    <Table>
      <thead>
        <tr>
          <Th>ID</Th>
          <Th>Name</Th>
          <Th>Category</Th>
          <Th>Price</Th>
          <Th>Stock</Th>
          <Th>Actions</Th>
        </tr>
      </thead>
      <tbody>
        {products.map((product, idx) => (
          <Tr key={product.id} odd={idx % 2 === 1}>
            <Td>{product.id}</Td>
            <Td>{product.name}</Td>
            <Td>{product.category}</Td>
            <Td>${product.price.toFixed(2)}</Td>
            <Td>{product.stock}</Td>
            <Td>
              <ActionBtn onClick={() => onEdit(product)}>Edit</ActionBtn>
              <ActionBtn onClick={() => onDelete(product.id)}>Delete</ActionBtn>
            </Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
};
export default ProductsTable;
